import { createAction, props } from "@ngrx/store";

export const updateAppTitle = createAction(
    "[AppTitle] Update Application Title",
    props<{ title: string }>()
  );